import { Divider, Frow, Heading2 } from '@pinpointhq/thumbtack';
import * as React from 'react';

interface IFormSectionProps {
  button?: React.ReactNode;
  className?: string;
  id?: string;
  title?: string;
  children: React.ReactNode;
  showDivider?: boolean;
}

export function FormSection(props: IFormSectionProps) {
  const { button, className, title, children, id, showDivider = true } = props;

  return (
    <div id={id} className={className}>
      <Frow alignContent="center" alignItems="center" justifyContent="space-between">
        {title && <Heading2>{title}</Heading2>}
        {button}
      </Frow>
      {children}
      {showDivider && <Divider className="mar-v-6" />}
    </div>
  );
}

export default FormSection;
